import { ShipmentMethod } from "@egocentric-systems/ts-apis/shop_config/types/v1/shipment_pb";
import { useIsShipingMethodActiveForCart } from "./useIsShipingMethodActiveForCart";
import { useShopConfig } from "./useShopConfig";
import { useCallback, useMemo } from "react";
import { CartItem, ReserveCancelRegister } from "~/lib/definitions";
import { useCart } from "./useCart";

export function useCheckDisabledShippingMethodsForItem() {
  const items = useCart(({ items }) => items);
  const seatUpgrades = useCart(({ seatUpgrades }) => seatUpgrades);

  const {
    shopConfig: { shipmentConfiguration },
  } = useShopConfig();

  const isShipingMethodActiveForCart = useIsShipingMethodActiveForCart();

  const shipmentMethods = useMemo(
    () =>
      shipmentConfiguration?.methods.filter(
        (method) =>
          method !== ShipmentMethod.UNSPECIFIED &&
          method !== ShipmentMethod.ON_SITE_PRINT,
      ) ?? [],
    [shipmentConfiguration],
  );

  return useCallback(
    (reservation: ReserveCancelRegister) => {
      if (items.length === 0 && seatUpgrades.length === 0) {
        return false;
      }

      const itemToCheck: CartItem = {
        ...reservation,
        discount: undefined,
        quantity: 1,
      };

      const disabledShippingMethods = shipmentMethods.filter(
        (method) =>
          isShipingMethodActiveForCart(method) &&
          !isShipingMethodActiveForCart(method, itemToCheck),
      );

      return disabledShippingMethods.length > 0;
    },
    [isShipingMethodActiveForCart, shipmentMethods, items, seatUpgrades],
  );
}
